import { InjectionToken } from '@angular/core';
export const CMS_API_BASE_URL = new InjectionToken<string>(
  'CMS_API_BASE_URL',
  { providedIn: 'root', factory: () => 'http://localhost:8080' }
);
/** Temporary hardcoded token for local dev — null in all other envs */
export const CMS_DEV_TOKEN = new InjectionToken<string | null>(
  'CMS_DEV_TOKEN',
  { providedIn: 'root', factory: () => null }
);
